import { useL10n } from '@uplift/hooks';
import { useFormStyles } from '../form-styles';
import { DateOfBirthInput, TextInput } from '../../../Inputs';

export const PrimarySubscriberForm = () => {
  const l10n = useL10n();
  const { classes } = useFormStyles();

  return (
    <div className={classes.formGroup}>
      <TextInput
        fullWidth
        id="primary-subscriber-first-name"
        name="primarySubscriberFirstName"
        label={l10n.accountSettings.firstName}
      />
      <TextInput
        fullWidth
        id="primary-subscriber-last-name"
        name="primarySubscriberLastName"
        label={l10n.accountSettings.lastName}
      />
      <div className={classes.width140}>
        <DateOfBirthInput
          id="primary-subscriber-date-of-birth"
          name="primarySubscriberDateOfBirth"
          label={l10n.accountSettings.dateOfBirth}
          helperText={l10n.accountSettings.dateOfBirthTip}
        />
      </div>
    </div>
  );
};
